import { CardService } from './CardService';

export type { TypeCardServiceProps } from './types';
export default CardService;
